import { render, staticRenderFns } from "./AvatarUsuario.vue?vue&type=template&id=1720e38a"
import script from "./AvatarUsuario.vue?vue&type=script&lang=js"
export * from "./AvatarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports